import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useGoals } from "./goals/useGoals";
import { getPacing } from "./goals/goalFormat";
import { GoalsHeader, PeriodSelector } from "./goals/GoalsHeader";
import { RevenueProgressCard } from "./goals/RevenueProgressCard";
import { GoalHierarchyCard } from "./goals/GoalHierarchyCard";
import { MilestonesCard, RecommendedActions } from "./goals/MilestonesCard";
import { CreateHierarchyModal } from "./goals/CreateHierarchyModal";

const GoalsView = ({ currentInstance }) => {
  const { userId } = useParams();
  const g = useGoals(userId, currentInstance);
  const [timePeriod, setTimePeriod] = useState("year");
  const [isEditing, setIsEditing] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [editData, setEditData] = useState({ revenueGoal: 0, currentRevenue: 0, goalEndDate: "" });

  const { revenueGoal, currentRevenue, goalEndDate } = g.effectiveData;
  useEffect(() => {
    setEditData({ revenueGoal, currentRevenue, goalEndDate });
  }, [revenueGoal, currentRevenue, goalEndDate]);

  if (g.loading || !g.deltaInfo) {
    return (
      <div className="flex items-center justify-center h-96" data-testid="goals-loading">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-ism-teal" />
      </div>
    );
  }

  const hasHierarchy = !!g.goalHierarchy?.hasHierarchy;
  const pacing = getPacing(revenueGoal > 0 ? (currentRevenue / revenueGoal) * 100 : 0);

  const handleSave = async () => {
    if (await g.saveGoals(editData)) setIsEditing(false);
  };
  const handleCancel = () => {
    setEditData({ revenueGoal, currentRevenue, goalEndDate });
    setIsEditing(false);
  };
  const handleCreate = async () => {
    if (await g.createHierarchy()) setShowCreateModal(false);
  };

  return (
    <div className="space-y-6" data-testid="goals-view">
      <GoalsHeader
        hasHierarchy={hasHierarchy}
        isEditing={isEditing}
        saving={g.saving}
        recalculating={g.recalculating}
        onCreate={() => setShowCreateModal(true)}
        onRecalculate={g.recalculate}
        onEdit={() => setIsEditing(true)}
        onCancel={handleCancel}
        onSave={handleSave}
      />
      <PeriodSelector value={timePeriod} onChange={setTimePeriod} />

      <RevenueProgressCard data={g.effectiveData} pipelineValue={g.goalHierarchy?.metrics?.currentPipeline} isEditing={isEditing} editData={editData} setEditData={setEditData} />

      {hasHierarchy && g.goalHierarchy.rootGoal && <GoalHierarchyCard hierarchy={g.goalHierarchy} />}
      {!hasHierarchy && <MilestonesCard revenueGoal={revenueGoal} currentRevenue={currentRevenue} onCreate={() => setShowCreateModal(true)} />}

      {pacing.status === "Behind" && g.deltaInfo.recommendedActions?.length > 0 && <RecommendedActions actions={g.deltaInfo.recommendedActions} />}

      <CreateHierarchyModal open={showCreateModal} onOpenChange={setShowCreateModal} form={g.createForm} setForm={g.setCreateForm} saving={g.saving} onCreate={handleCreate} />
    </div>
  );
};

export default GoalsView;
